import React from "react";
import {
    Box,
    useTheme,
    Typography,
    Switch,
    Button,
    TextField,
    useMediaQuery,
} from "@mui/material";
import { ResponsiveLine } from "@nivo/line";
import { tokens } from "../../Theme/theme";
import '../../assets/fonts/fonts.css'
import { linearGradientDef } from "@nivo/core";

const LineChart = ({ data, color, enableArea }) => {
    const isMobileScreen = useMediaQuery('(max-width:500px)');
    const isTabScreen = useMediaQuery('(max-width:1200px)')
    console.log(data);
    if (!data) {
        return <Box></Box>;
    }
    return (
        // <Box>
        <ResponsiveLine
            data={data}
            margin={{ top: 40, right: (isMobileScreen || isTabScreen) ? 20 : 30, bottom: 40, left: (isMobileScreen || isTabScreen) ? 30 : 40 }}
            xScale={{ type: 'point' }}
            yScale={{
                type: 'linear',
                min: '0',
                max: 'auto',
                stacked: true,
                reverse: false
            }}
            axisTop={null}
            curve={'natural'}
            enableGridX={false}
            axisRight={null}
            motionConfig="gentle"
            axisBottom={{
                tickSize: 5,
                tickPadding: (isMobileScreen || isTabScreen) ? 5 : 15,
                tickRotation: (isMobileScreen || isTabScreen) ? -45 : 0,
                //legend: enableArea ? "Month" : 'Date',
                legendOffset: 36,
                legendPosition: 'middle',
                truncateTickAt: 0
            }}
            defs={[
                linearGradientDef('singleGradient', [
                    { offset: 0, color: '#ff6b00', opacity: 0.35 },
                    { offset: 70, color: '#ff6b00', opacity: 0.10 },
                    { offset: 100, color: '#ff6b00', opacity: 0 }
                ])
            ]}

            fill={[
                { match: '*', id: 'singleGradient' }
            ]}

            axisLeft={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                //legend: enableArea ? 'Accounts Created' : 'Active Users',
                legendOffset: -40,
                legendPosition: 'middle',
                truncateTickAt: 0
            }}
            theme={{
                tooltip: {
                    container: {
                        background: "#303030",
                        color: "#ffffff",
                    },
                },

                // background: "#ffff",
                fontSize: "9px",
                textColor: "#ffffff",
                fontFamily: 'poppins-reg',
                grid: {
                    line: {
                        stroke: "#ffffff20", // Set the color of the grid lines here
                        strokeWidth: 0.5,
                        strokeDasharray: "5 5"
                    },
                },
            }}
            colors={color}
            pointSize={2}
            enableArea={enableArea}
            enablePointLabel={true}
            pointColor={"#ffffff"}
            pointBorderWidth={0}
            pointBorderColor={"#ffffff"}
            pointLabel="data.yFormatted"
            pointLabelYOffset={-12}
            enableTouchCrosshair={true}
            useMesh={true}
            legends={[
                {
                    anchor: 'top-right',
                    direction: 'column',
                    justify: false,
                    translateX: -5,
                    translateY: -20,
                    itemsSpacing: 0,
                    itemDirection: 'left-to-right',
                    itemWidth: 80,
                    itemHeight: 20,
                    itemOpacity: 0.75,
                    symbolSize: 12,
                    symbolShape: 'circle',
                    symbolBorderColor: 'rgba(0, 0, 0, .5)',
                    effects: [
                        {
                            on: 'hover',
                            style: {
                                itemBackground: 'rgba(0, 0, 0, .03)',
                                itemOpacity: 1
                            }
                        }
                    ]
                }
            ]}
        />
        // </Box>
    );
};

export default LineChart;
